<ion-header *ngIf="chatGroup$ | async" class="ion-no-border">
  <ion-item lines="full">
    <ion-button (click)="goBack()" id="back" tooltip="Back">
      <ion-icon src="/assets/icons/24px/chevron-left.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-label>
      <h6 class="bold">
        {{ (chatGroup$ | async).name }}
      </h6>
    </ion-label>

    <ion-button
      (click)="openInviteChatGroupMenu($event)"
      tooltip="Invite to Group"
      aria-label="Invite to Group"
      *ngIf="
        (chatGroup$ | async).name !== defaultChatGroups.EVERYONE &&
        (chatGroup$ | async).name !== defaultChatGroups.BACKSTAGE &&
        (chatGroup$ | async).name !== defaultChatGroups.STAGE &&
        (role$ | async) >= roleLimits.CHAT_GROUP_UPDATE
      ">
      <ion-icon src="/assets/icons/24px/invite.svg" slot="start"> </ion-icon>

      {{ (chatGroup$ | async)?.users?.length }}
    </ion-button>

    <ion-button
      (click)="deleteChatGroup()"
      tooltip="Delete Chat Group"
      aria-label="Delete Chat Group"
      *ngIf="
        (chatGroup$ | async).name !== defaultChatGroups.EVERYONE &&
        (chatGroup$ | async).name !== defaultChatGroups.BACKSTAGE &&
        (chatGroup$ | async).name !== defaultChatGroups.STAGE &&
        (role$ | async) >= roleLimits.CHAT_GROUP_DELETE
      ">
      <ion-icon src="/assets/icons/24px/delete.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-button (click)="closeSidebar.emit()" tooltip="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only" aria-label="Close Chat Group"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>

<ion-content *ngIf="chatGroup$ | async" (ionScroll)="onScroll($event)" [scrollEvents]="true">
  <ion-list>
    <div id="about">
      <p class="micro-bold ion-text-center">
        <ion-icon src="/assets/icons/24px/lock.svg"></ion-icon>
        Private and Secure Messaging
      </p>

      <p class="micro-regular ion-text-center">
        Messages can only be seen by members of this group.<br />
        @mentions, /commands, and reactions are a thing.
      </p>
    </div>

    <div *ngIf="chatMessages; else loading">
      <sc-chat-message
        *ngFor="let chatMessage of chatMessages; trackBy: trackByChatMessage; last as last"
        [chatMessage]="chatMessage"
        [participants]="(dolbyConversation$ | async) && dolbyParticipants || (dailyCall$ | async) && dailyParticipants"
        [chatGroupID]="chatGroupID"
        (scrollToBottom)="scrollToBottom()"></sc-chat-message>
    </div>

    <ng-template #loading>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </ng-template>
  </ion-list>
</ion-content>

<div id="chat-box" *ngIf="chatGroup$ | async">
  <div *ngIf="scrollingDisabled" (click)="scrollingDisabled = false; scrollToBottom()" class="back-to-bottom">
    <ion-icon src="/assets/icons/24px/chevron-down.svg"></ion-icon>
    <p>Back To Bottom</p>
    <ion-badge *ngIf="unreadCount">{{ unreadCount }}</ion-badge>
  </div>

  <ion-item *ngIf="gifMenuOpen !== true" lines="none">
    <input type="text" *ngIf="!mentionConfig" placeholder="Loading..." disabled />
    <input
      type="text"
      *ngIf="mentionConfig"
      (keydown.enter)="sendChatMessage()"
      [(ngModel)]="newMessage"
      [mentionConfig]="mentionConfig"
      scAutoFocus
      placeholder="Send messages to the group..." />

    <ion-button
      (click)="toggleGifMenu()"
      class="secondary gif-button"
      size="small"
      tooltip="Search Giphy"
      aria-label="Search Giphy">
      <ion-icon src="/assets/icons/24px/gif.svg" slot="icon-only"></ion-icon>
    </ion-button>

    <ion-button
      (click)="sendChatMessage()"
      class="primary"
      size="small"
      tooltip="Send Message"
      aria-label="Send Chat Message">
      <ion-icon src="/assets/icons/24px/send-solid.svg" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-item>

  <ion-row *ngIf="gifMenuOpen">
    <sc-gif-selector (selected)="insertGif($event)" (back)="toggleGifMenu()" [gifSearchQuery]="gifSearchQuery"> </sc-gif-selector>
  </ion-row>

  <div id="chat-box-tour-container"></div>
</div>
